<script>
import PubSub from 'pubsub-js'
import {throttle} from '../../../utils/util'
import {handleTraceSearchLog} from '../../../utils/trace'

export default {
  name: 'TechnologySearch',
  props: {
    value: {
      type: String,
      default: '',
      required: true
    },
    queryParam: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      val: '',
      searchLoading: false
    }
  },
  watch: {
    value: {
      handler(val) {
        this.val = val
      },
      immediate: true
    },
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    entrance() {
      let entrance = ''
      switch (this.queryParam.type) {
        case '1':
          switch (this.queryParam.firstClassify) {
            case '术式方案':
              entrance = '62'
              break
            case '技术前沿':
              entrance = '63'
              break
            case '专科发展':
              entrance = '64'
              break
            case '诊疗发展':
              entrance = '65'
              break
            default:
              break
          }
          break
        case '2':
          entrance = '61'
          break
        default:
          break
      }
      return entrance
    }
  },
  methods: {
    handleTraceSearch() {
      handleTraceSearchLog({
        'userId': this.userInfo.id,
        'searchContent': this.val,
        'sessionId': localStorage.getItem('sessionId'),
        'type': 15,
        'entrance': this.entrance,
      })
    },
    updateValue(value) {
      this.$emit('input', value)
    },
    search: throttle(function () {
      if (this.searchLoading) return
      PubSub.publish('TechnologySearch')
      this.handleTraceSearch()
      this.searchLoading = true
    }, 500),
  }
}
</script>

<template>
  <div class="search-box">
    <div class="search-cont">
      <img src="@/assets/images/technology/img3.png" class="border-img" alt="">
      <van-search
        v-model="val"
        shape="round"
        class="border-input"
        placeholder="搜索"
        @input="updateValue"
        @search="search"
      />
      <div class="border-btn" @click.stop="search" v-track="{ functionName: '新技术搜索' }">
        <img src="@/assets/images/technology/search-icon.png" class="icon-search" alt="">
        <span class="btn-txt">搜索</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.search-box {
  width: 100%;
  box-sizing: border-box;
  padding: 15px 15px 10px;
  position: sticky;
  background: #F7F9FB;
  top: 0;
  left: 0;
  z-index: 999;

  .search-cont {
    display: flex;
    align-items: center;
    border: 1px solid #C8C9CC;
    border-radius: 90px;
    height: 29.44px;
    padding: 3px;
    box-sizing: border-box;
    background: #fff;

    .border-img {
      width: 34px;
      display: block;
      margin-right: 2px;
      padding-left: 6px;
      box-sizing: border-box;
    }

    .border-input {
      border: none;
      outline: none;
      color: #949BA5;
      padding: 0;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      background-color: transparent;
      flex: 1;

      /deep/ .van-search__content {
        background: transparent;
        padding-left: 0;

        .van-cell {
          padding: 0;

          .van-field__control {
            &::placeholder {
              color: #949BA5;
            }
          }
        }

        .van-field__left-icon {
          display: none;
        }
      }
    }

    .border-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 26px;
      background-color: #F7F8FA;
      border-radius: 100px;

      .icon-search {
        width: 13px;
        display: block;
        margin-right: 4px;
      }

      .btn-txt {
        color: #898A8C;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/technology/modules/TechnologySearch.vue